import { Link } from "react-router-dom";

export function ListingFooter({ slug, brandLabel, brokerage, disclosure, preview }) {
  const base = `/listing/${slug}`;
  const qs = preview ? "?preview=1" : "";
  return (
    <footer data-testid="listing-footer" className="bg-[#111820] text-white/55 pb-20 md:pb-0">
      <div className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-10 py-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div>
          <p className="text-white/85 font-serif-display text-base">{brandLabel}</p>
          {brokerage && <p className="text-xs mt-1">{brokerage}</p>}
        </div>
        <nav className="flex flex-wrap gap-5 text-xs">
          <Link to={`${base}${qs}`} data-testid="listing-footer-home" className="hover:text-white">Home</Link>
          <Link to={`${base}/details${qs}`} data-testid="listing-footer-details" className="hover:text-white">Details</Link>
          <Link to={`${base}/sponsors${qs}`} data-testid="listing-footer-sponsors" className="hover:text-white">Sponsors</Link>
          <Link to={`${base}/sponsors${qs}#advertise`} data-testid="listing-footer-advertise" className="hover:text-white">Advertise Here</Link>
        </nav>
      </div>
      <div className="border-t border-white/10 px-4 sm:px-6 lg:px-10 py-4 text-[11px] text-white/35 max-w-[1360px] mx-auto">
        {disclosure || "Information deemed reliable but not guaranteed. Please verify all details independently."}
      </div>
    </footer>
  );
}
